import { useHeroImage } from './useHeroImage';
/** Sends useHeroImage container dimensions based on passed-in ref
 *  and useHeroImage sends back the appropriate deviation hero Image
 *  for that size. */ export const useHeroImageForContainer = (deviation, container)=>{
    return useHeroImage(deviation, container.current ? container.current.clientWidth : 0, container.current ? container.current.clientHeight : 0);
};
